import React, { useEffect, useState } from 'react';
import { devServerApi } from '@/shared/apis/devServerApi';
import { useAuthStore } from '@/stores/common/useAuthStore';

const CommonProvider = ({ children }): React.ReactElement => {
  return <>{children}</>;
};

export default CommonProvider;
